module.exports = "pegasus_template/assets/hexline-google.png";